/** 화면의 두 그리드를 구분하는 값이다. allow는 위쪽 지급항목, deduct는 아래쪽 공제항목 그리드이다. */
export type HRM3110_R01GridType = 'allow' | 'deduct';

/** 지급 구분 코드(AD_TYPE A)이다. */
export const ALLOW_DEDUCT_TYPE_ALLOW = 'A';
/** 공제 구분 코드(AD_TYPE D)이다. */
export const ALLOW_DEDUCT_TYPE_DEDUCT = 'D';
/** 과세 코드(TAX_TYPE T)이다. 지급 신규 행의 과세구분 기본값이다. */
export const TAX_TYPE_TAXABLE = 'T';
/** 비과세 코드(TAX_TYPE N)이다. 비과세한도는 이 과세구분에서만 입력할 수 있다. */
export const TAX_TYPE_NONTAX = 'N';
/** 해당없음 코드(TAX_TYPE -)이다. 공제 신규 행의 과세구분 기본값이다. */
export const TAX_TYPE_NONE = '-';

/**
 * 급여·상여·연말정산 계산 로직이 코드값을 직접 참조하는 시스템 항목 목록이다.
 * 삭제 표시를 막는다. 백엔드 HRM3110_R01Service의 SYSTEM_CODES와 같은 값을 유지해야 한다.
 * D12·D13은 연말정산 확정 결과를 급여에 반영할 때 쓰므로 화면 정의서(D11까지)보다 넓게 보호한다.
 */
export const SYSTEM_ALLOW_DEDUCT_CODES: readonly string[] = [
    'P01', 'P02', 'P03', 'P04', 'P05', 'P06', 'P07', 'P08', 'P09', 'P10', 'P11', 'P12',
    'D01', 'D02', 'D03', 'D04', 'D05', 'D06', 'D07', 'D08', 'D09', 'D10', 'D11', 'D12', 'D13',
];

/**
 * 시스템 항목 여부를 판단한다.
 * @param allowDeductCd 검사할 수당·공제코드
 * @returns 시스템 항목이면 true
 */
export const isSystemAllowDeductCode = (allowDeductCd: string) =>
    SYSTEM_ALLOW_DEDUCT_CODES.includes(allowDeductCd.trim().toUpperCase());

/**
 * 그리드 종류에 맞는 구분 코드를 반환한다.
 * @param gridType 지급 또는 공제 그리드
 * @returns 지급이면 A, 공제이면 D
 */
export const getAllowDeductType = (gridType: HRM3110_R01GridType) =>
    // 삼항 연산자: 지급 그리드이면 A, 공제 그리드이면 D를 반환한다.
    gridType === 'allow' ? ALLOW_DEDUCT_TYPE_ALLOW : ALLOW_DEDUCT_TYPE_DEDUCT;

/** 지급 그리드 컬럼의 필드명과 사용자 표시명을 연결한다. */
export const allowHeaderNames_HRM3110_R01: Record<string, string> = {
    rowIndex: '',
    allowDeductCd: '코드',
    allowDeductNm: '항목명',
    allowDeductType: '구분',
    taxType: '과세구분',
    ordinaryYn: '통상임금',
    nontaxLimit: '비과세한도',
    salaryYn: '급여대상',
    bonusYn: '상여대상',
    useYn: '사용',
    sortSeq: '순서',
    remark: '비고 / 연결 기준표',
};

/** 공제 그리드 컬럼의 필드명과 사용자 표시명을 연결한다. 같은 salaryYn·bonusYn을 급여공제·상여공제로 표시한다. */
export const deductHeaderNames_HRM3110_R01: Record<string, string> = {
    rowIndex: '',
    allowDeductCd: '코드',
    allowDeductNm: '항목명',
    allowDeductType: '구분',
    taxType: '과세구분',
    salaryYn: '급여공제',
    bonusYn: '상여공제',
    useYn: '사용',
    sortSeq: '순서',
    remark: '비고 / 연결 기준표',
};
